import React from 'react';
import { useTranslation } from 'react-i18next';

interface LanguageSelectorProps {
  className?: string;
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({ className = '' }) => {
  const { i18n } = useTranslation();

  const languages = [
    { code: 'en', name: 'English', flag: '🇺🇸' },
    { code: 'hr', name: 'Hrvatski', flag: '🇭🇷' },
    { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  ];

  const handleLanguageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedLanguage = event.target.value;
    i18n.changeLanguage(selectedLanguage);
    localStorage.setItem('userLanguage', selectedLanguage);
    localStorage.setItem('languageManualOverride', 'true');
  };

  return (
    <div className="relative">
      <select 
        value={i18n.language} 
        onChange={handleLanguageChange}
        className={`
          bg-white/95 border-2 border-white/80 rounded-lg px-3 py-2 text-sm font-medium
          text-gray-800 shadow-lg backdrop-blur-sm cursor-pointer
          hover:bg-white hover:border-white hover:shadow-xl
          focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-400
          transition-all duration-200 ease-in-out
          appearance-none pr-8
          ${className}
        `}
        style={{
          backgroundImage: `url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e")`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'right 8px center',
          backgroundSize: '16px',
        }}
      >
        {languages.map((lang) => (
          <option 
            key={lang.code} 
            value={lang.code}
            className="bg-white text-gray-800 py-2 px-3"
          >
            {lang.flag} {lang.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LanguageSelector; 